import { Button, ErrorListItem } from '@razz-team/ui-web';
import { useTranslation } from 'react-i18next';
import { MainLayout } from '../../Layout/MainLayout';
import { useBusinessMemberQuery, useUpdateBusinessMemberMutation } from '../../../api/members';
import { MainBreadcrumbs } from '../../Layout/MainBreadcrumbs';
import { Route } from '../../../routes/account.members_.$customerId_.edit';
import { MemberForm } from './MemberForm';
import { useCallback, useEffect } from 'react';
import { useBoolean } from 'usehooks-ts';
import { DeleteMemberDialog } from './Member/DeleteMemberDialog';
import { getMemberDisplayName, getMemberEmail } from './Member/utils';

export function EditMemberPage() {
  const { t } = useTranslation();
  const navigate = Route.useNavigate();
  const { customerId } = Route.useParams();
  const memberQuery = useBusinessMemberQuery({ customerId });
  const updateMemberMutation = useUpdateBusinessMemberMutation({ customerId });
  const deleteFlag = useBoolean(false);

  const goToBusinessPage = useCallback(
    () => navigate({ to: '/account/business', replace: true }),
    [navigate],
  );

  useEffect(() => {
    if (updateMemberMutation.isSuccess) {
      goToBusinessPage();
    }
  }, [updateMemberMutation.isSuccess, goToBusinessPage]);

  const memberName =
    getMemberDisplayName(memberQuery.data) ?? getMemberEmail(memberQuery.data) ?? t('Member');

  return (
    <MainLayout
      title={
        <MainBreadcrumbs
          title={t('Edit member')}
          parent={{
            to: '/account/members/$customerId',
            params: { customerId },
            title: memberName,
            loading: memberQuery.isPending,
          }}
        />
      }
      actions={
        memberQuery.isSuccess ? (
          <Button variant="outlined" size="small" onClick={deleteFlag.setTrue}>
            {t('Delete')}
          </Button>
        ) : undefined
      }
    >
      {memberQuery.isSuccess ? (
        <>
          <MemberForm mutation={updateMemberMutation} defaultValues={memberQuery.data} />
          <DeleteMemberDialog
            member={deleteFlag.value ? memberQuery.data : undefined}
            onCancel={deleteFlag.setFalse}
            onSuccess={goToBusinessPage}
          />
        </>
      ) : memberQuery.isError ? (
        <ErrorListItem error={memberQuery.error} />
      ) : null}
      {/* TODO: add loading state */}
    </MainLayout>
  );
}
